import { useEffect } from 'react';
import { HistoryShortcut, resolveHistoryShortcut } from '../shell/shortcuts';
import { useUndoActions } from './useUndo';

/** Global Ctrl/Cmd+Z, Ctrl/Cmd+Shift+Z and Ctrl+Y. */
export function useHistoryShortcuts(): void {
  const { undo, redo } = useUndoActions();
  useEffect(() => {
    function onKeyDown(event: KeyboardEvent): void {
      if (event.defaultPrevented) return;
      const action = resolveHistoryShortcut(event);
      if (action === null) return;
      event.preventDefault();
      void (action === HistoryShortcut.Undo ? undo() : redo());
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [undo, redo]);
}
